import { sortBy } from 'lib/array/arrayUtils'

function hasSameTerms(candidate: App.BedbankRate, rate: App.BedbankRate): boolean {
  return candidate.roomId === rate.roomId &&
    candidate.boardCode === rate.boardCode &&
    candidate.refundable === rate.refundable &&
    candidate.partiallyRefundable === rate.partiallyRefundable &&
    candidate.isFlightBundle === rate.isFlightBundle &&
    candidate.paymentMethod === rate.paymentMethod
}

/**
 * The public source's version of a rate, once a flagged shopper is priced at the public rate.
 *
 * The same rate keeps its id, or at least its room and rate group. Google's price-matched rate can
 * be fulfilled by another supplier than the public one, under a different id and group, so it falls
 * back to the cheapest public rate for the same room on the same terms. Undefined when the public
 * source has none.
 */
export function findPublicBedbankRate(publicRates: Array<App.BedbankRate>, rate: App.BedbankRate): App.BedbankRate | undefined {
  return publicRates.find(candidate => candidate.id === rate.id) ??
    publicRates.find(candidate => candidate.roomId === rate.roomId && candidate.groupId === rate.groupId) ??
    sortBy(publicRates.filter(candidate => hasSameTerms(candidate, rate)), candidate => candidate.totals.inclusive, 'asc')[0]
}
